import * as Sentry from "@sentry/react-native";
import AsyncStorage from "@react-native-async-storage/async-storage";
import CheckBox from "@react-native-community/checkbox";
import HyperSdkReact from "hyper-sdk-react";
import debounce from "lodash/debounce";
import React, { Component, createContext } from "react";
import {
  ActivityIndicator,
  Alert,
  BackHandler,
  Dimensions,
  Image,
  NativeEventEmitter,
  NativeModules,
  PixelRatio,
  ScrollView,
  SectionList,
  StyleSheet,
  TouchableOpacity,
  View,
} from "react-native";
// payment related imports
import ViewShot from "react-native-view-shot";
import { connect } from "react-redux";
import CartEmpty from "@assets/svg/CartEmpty";
import Text from "@components/AppText";
import Button from "@components/Button";
import FetchCMSEntity from "@components/CMS/FetchCMSEntity";
import RadioButton from "@components/RadioButton";
import {
  THANK_YOU_ORDER_DETAILS,
  ORDER_FLOW_EVENTS,
  SHARING_EVENTS,
} from "@constants/analyticsEventsCT";
import cartPageKeys from "@constants/cartPageKeys";
import colors from "@constants/color";
import metrics from "@constants/metrics";
import { actions as authActions } from "@reducers/authReducer";
import {
  actions as cartActions,
  getAddedProductListIds,
} from "@reducers/cartReducer";
import { actions as configActions } from "@reducers/configReducer";
import { actions as customerActions } from "@reducers/customerReducer";
import { actions as refreshActions } from "@reducers/refreshReducer";
import {
  availablePaymentMethods,
  juspayStatus,
  no,
  yes,
} from "@constants/juspayEnums";
import { actions } from "@reducers/orderReducer";
import analytics from "@services/analytics";
import {
  applyCouponCode,
  completePayment,
  dontUseCashBack,
  getCartCMS,
  placeOrder,
  removeCouponCode,
  useCashBack,
  whatsAppOpt,
} from "@services/api";
import t from "@constants/localization";
import testIds from "@constants/testIds";
import PlaceOrderHOC from "./PlaceOrderHOC";
import AddressConfirmationModal from "./AddressConfirmationModal";
import CartProductItem from "./CartProductItem";
import DiscountView from "./DiscountView";
import OssModal from "./OssModal";
import placeOrderHOC from "./PlaceOrderHOC";

const PATH = "screens/PlaceOrder/PlaceOrderView";

export const { width, height } = Dimensions.get("window");
const scale = width / 360;
let trackEventPayload;
export const normalize = (size) => {
  const newSize = size * scale;
  return Math.round(PixelRatio.roundToNearestPixel(newSize));
};
let ordrId = "";

export const CartContext = createContext();
class PlaceOrderView extends Component {
  constructor(props) {
    super(props);

    this.state = {
      placeOrderSuccessModalVisible: false,
      removedItemsFromCartModalShown: false,
      removedItems: [],
      removeUnavailable: false,
      isWhatsappOpted: true,
      isOrderSubmitting: false,
      isFirstLoad: true,
      paymentMethod: null,
      order_id: "",
      cart: {},
      order_ids: [],
      showAddressConfirmation: false,
      isLargeAppliancePresent: false,
    };
    this.timer = null;
  }

  viewShotRef;

  initiateResult({ result, event, payload }) {
    if (payload.status === "success") {
      this.props.dispatch(
        configActions.setHyperSDKInitialized({
          hyperSDKInitialized: true,
        }),
      );
    } else {
      this.props.dispatch(
        configActions.setHyperSDKInitialized({
          hyperSDKInitialized: false,
        }),
      );
    }
  }

  processResult({ result, event, payload }) {
    const { error } = result;
    const innerPayload = result.payload || {};
    const status = innerPayload.status || "";
    if (!error) {
      if (status === juspayStatus.cod_initiated) {
        trackEventPayload.payment_method = availablePaymentMethods.cod;
        this.handleCompleteOrder(yes, ordrId, trackEventPayload);
      } else {
        this.handleCompleteOrder(no, ordrId, trackEventPayload);
      }
    } else {
      if (status === juspayStatus.backpressed) {
      } else {
        const errorMessage = t(`${PATH}/paymentFailed`);
        Alert.alert("", `${errorMessage}`);
      }
      this.setState({ isOrderSubmitting: false });
    }
  }

  componentDidMount() {
    this.props.setInitiateResult(() => this.initiateResult.bind(this));
    this.props.setProcessResult(() => this.processResult.bind(this));
    this.focusNavigation = this.props.navigation.addListener("focus", () => {
      this.getCart();
    });
  }

  componentWillUnmount() {
    this.props.dispatch(configActions.setHeaderTitle(""));
    this.clearCart();
    this.focusNavigation();
  }

  setDynamicTitle = (title) => {
    this.props.dispatch(configActions.setHeaderTitle(title));
  };

  setCommission = (value) => {
    this.props.dispatch(cartActions.setCommission(value));
  };

  getCart() {
    if (
      this.props.dispatch &&
      this.selectedUserId &&
      !this.state.placeOrderSuccessModalVisible
    ) {
      this.getCartCMS();

      if (this.timer !== null) {
        clearTimeout(this.timer);
        this.timer = null;
      }

      this.timer = setTimeout(() => {
        this.getCart();
      }, 10000);
    }
  }

  getCartCMS = () => {
    if (this.selectedUserId) {
      getCartCMS(this.selectedUserId)
        .then(({ data }) => {
          let { paymentMethod } = this.state;
          if (!paymentMethod) {
            paymentMethod = data?.cartPage?.find(
              (cartItem) => cartItem.type === "paymentOptionsV2",
            )?.default_method;
          }
          this.setState({
            cart: data,
            isFirstLoad: false,
            paymentMethod,
          });
          this.checkIfLargeAppliancePresent(data?.cartPage);
          this.setDynamicTitle(data.header && data.header.title);
          this.setCommission(data.expectedCommission);
        })
        .catch((error) => {
          console.log(error);
          console.log(error.response);
        });
    }
  };

  clearCart = () => {
    if (this.timer !== null) {
      clearTimeout(this.timer);
    }
  };

  showPlaceOrderSuccessModal = (order_details = {}) => {
    const {
      orders = [],
      billingDetails = [],
      commission,
      eventPayload: { order_id = "" },
    } = order_details;
    this.setState(
      {
        placeOrderSuccessModalVisible: true,
        removeUnavailable: false,
        removedItems: [],
        removedItemsFromCartModalShown: false,
      },
      () => {
        this.props.navigation.replace("PlaceOrderSuccess", {
          splitOrders: orders,
          billingDetails,
          commission,
          orderId: order_id,
        });
        this.props.dispatch(customerActions.setSelectedContact(false));
      },
    );
  };

  showRemoveItemsFromCartModal = () =>
    this.setState({ removedItemsFromCartModalShown: true });

  hidePlaceOrderSuccessModal = () => {
    analytics.trackEvent(THANK_YOU_ORDER_DETAILS, {
      order_id: ordrId || "",
    });
    this.props.dispatch &&
      this.props.dispatch(cartActions.getAllCartItems(this.selectedUserId));
    this.props.navigation.replace("OrderDetails", {
      goBackScreenName: "Orders",
    });
  };

  hideRemoveItemsFromCartModal = () => {
    this.setState({ removedItemsFromCartModalShown: false });
  };

  removeItemsAndPlaceOrder = () => {
    this.setState(
      {
        removedItemsFromCartModalShown: false,
        removeUnavailable: true,
      },
      () => {
        this.placeOrder();
      },
    );
  };

  hideRemoveItemsFromCartModal = () => {
    this.setState({ removedItemsFromCartModalShown: false });
  };

  removeItemsAndPlaceOrder = () => {
    this.setState(
      {
        removedItemsFromCartModalShown: false,
        removeUnavailable: true,
      },
      () => {
        this.placeOrder();
      },
    );
  };

  checkForOOSProducts = async (skipLargeApplianceCheck = false) => {
    if (!this.state.paymentMethod) {
      Alert.alert("पेमेंट मेथड चुने", "कृपया पेमेंट मेथड चुने");
      return;
    }
    if (this.state.cart.showOosWarning) {
      this.setState({
        removedItemsFromCartModalShown: true,
      });
    } else {
      if (!this.state.isOrderSubmitting) {
        await this.placeOrder(false, skipLargeApplianceCheck);
      }
    }
  };

  handleCompleteOrder = (is_cod, order_id, trackEventPayload, response) => {
    let completeOrderPromise;
    if (response) {
      completeOrderPromise = completePayment({ is_cod, order_id, ...response });
    } else {
      completeOrderPromise = completePayment({ is_cod, order_id });
    }

    completeOrderPromise
      .then(async ({ data }) => {
        const {
          payment_method,
          amount_after_discount,
          cart_value,
          ...eventPayload
        } = data.eventPayload;
        analytics.trackEvent(ORDER_FLOW_EVENTS.ORDER_COMPLETE, {
          ...trackEventPayload,
          ...eventPayload,
          payment_status: payment_method,
          payable_amount: amount_after_discount,
          total_cart_value: cart_value,
        });

        const { whatsapp_opted_in = false } = this.props.user || {};

        if (!whatsapp_opted_in) {
          whatsAppOpt(this.state.isWhatsappOpted).catch((e) => {
            console.log(e);
          }); // whatsapp opt api call
        }
        this.props.dispatch(refreshActions.silentRefresh());
        this.clearCart();
        this.handlePlaceOrderSuccess(data);
        this.setState({ isOrderSubmitting: false });
      })
      .catch((e) => {
        console.log(e);
        this.setState({ isOrderSubmitting: false });

        analytics.trackEvent(ORDER_FLOW_EVENTS.ORDER_CANCELLED, {
          payload: trackEventPayload,
        });

        if (this.state.paymentMethod !== "COD") {
          const errorMessage = t(`${PATH}/paymentFailed`);
          Alert.alert("", `${errorMessage}`);
        } else {
          Alert.alert("", t(`${PATH}/tryAgain`));
        }

        this.getCart();

        if (!e.response || !e.response.data) {
          return;
        }

        if (
          e.response.data.error === "REMOVE_PRODUCTS_FROM_CART" &&
          Array.isArray(e.response.data.removedItems) &&
          e.response.data.removedItems.length > 0
        ) {
          this.showRemoveItemsFromCartModal(e.response.data.removedItems);
        }
      });
  };

  checkIfLargeAppliancePresent = (cartPage = []) => {
    const cartItemsByEdd =
      cartPage &&
      cartPage.find((item) => item.type === cartPageKeys.CART_ITEMS_BY_EDD);

    const checkLargeAppliancePresent = cartItemsByEdd?.items?.some((eddItem) =>
      eddItem.items.some(
        (item) =>
          item.item_size === cartPageKeys.LARGE_APPLIANCES ||
          item.item_size === cartPageKeys.LARGE,
      ),
    );
    this.setState({ isLargeAppliancePresent: checkLargeAppliancePresent });
  };

  initiateJuspayPaymentPage = (data) => this.props.processPayment(data);

  placeOrder = async (
    removeUnavailable = false,
    skipLargeApplianceCheck = true,
  ) => {
    const { user, dispatch } = this.props;
    if (user?.is_suspended || user?.leader_state === "LEADER_SUSPENDED") {
      dispatch(authActions.showSuspensionModal(true));
      return;
    }
    const { isLargeAppliancePresent, showAddressConfirmation } = this.state;
    if (isLargeAppliancePresent && !skipLargeApplianceCheck) {
      this.setState({ showAddressConfirmation: true }, () => {
        analytics.trackEvent(ORDER_FLOW_EVENTS.DETAIL_CONFIRMATION_OPENED);
      });
      return;
    } else if (isLargeAppliancePresent && skipLargeApplianceCheck) {
      showAddressConfirmation &&
        this.setState({ showAddressConfirmation: false }, () => {
          analytics.trackEvent(ORDER_FLOW_EVENTS.ADDRESS_CONFIRM_CLICK, {
            screen_name: "Detail Confirmation Pop",
          });
        });
    }

    this.setState({ isOrderSubmitting: true });
    const payload = {
      userId: this.props.selectedContact.user_id,
      language: "hi",
      paymentMethod: this.state.paymentMethod,
      groupBuy: false,
      fromCart: true,
      removeUnavailable,
    };

    try {
      const tracking_info =
        JSON.parse(await AsyncStorage.getItem("TRACKING_INFO")) || {};

      if (
        tracking_info &&
        tracking_info.time &&
        Date.now() - tracking_info.time < 86400000
      ) {
        payload.trackingInfo = tracking_info;
      } else {
        payload.trackingInfo = {
          installParams: tracking_info && tracking_info.installParams,
        };
      }
    } catch (e) {
      console.log(e);
    }

    const { currentCartSkuIds, cart } = this.props;

    const cartItemQty =
      cart?.cartItems?.reduce((acc, curr) => (acc += curr.quantity), 0) || "";

    const cartTotalItems = cart?.cartItems?.length || "";

    trackEventPayload = {
      payment_method: this.state.paymentMethod, // todo - add selection for COD / ONLINE
      total_quantity: cartItemQty,
      total_items: cartTotalItems,
      ...currentCartSkuIds,
    };

    this.clearCart();

    placeOrder(payload)
      .then(async ({ data }) => {
        ordrId = data.order_id;
        if (ordrId) {
          if (payload.paymentMethod === "JUSPAY") {
            await this.initiateJuspayPaymentPage(data);
          } else if (payload.paymentMethod === "COD") {
            this.handleCompleteOrder("YES", ordrId, trackEventPayload);
          } else {
            Sentry.captureMessage(
              `Invalid payment method ${payload.paymentMethod}`,
            );
          }
        } else {
          Sentry.captureMessage("create-order-2 did not return an Order Id");
        }
      })
      .catch((e) => {
        this.setState({
          isOrderSubmitting: false,
        });
        console.log(e);
      });
  };

  handlePlaceOrderSuccess = (orderDetails) => {
    const payload = {
      offset: 0,
      limit: 10,
      replace: true,
      orderCompleted: true,
    };
    this.props.dispatch(cartActions.resetCart());
    this.props.dispatch(actions.getAllOrdersReq(payload));
    this.props.dispatch(authActions.getUserDetailsByTokenRequest());
    this.showPlaceOrderSuccessModal(orderDetails);
  };

  applyCouponCode = (couponCode) => {
    const { user_id = "" } = this.props.selectedUser;

    return applyCouponCode({ couponCode, user_id })
      .then(() => {
        this.getCartCMS();
        this.props.dispatch(cartActions.getAllCartItems(user_id));
      })
      .catch((e) => {
        console.log(e.response);
      });
  };

  removeCouponCode = () => {
    const { user_id = "" } = this.props.selectedContact;
    return removeCouponCode({ user_id })
      .then(() => {
        this.getCartCMS();
        this.props.dispatch(cartActions.getAllCartItems(user_id));
      })
      .catch((e) => {
        console.log(e);
      });
  };

  toggleUseCashBack = (checkValue) => {
    if (checkValue) {
      useCashBack(this.selectedUserId)
        .then((response) => {
          this.getCartCMS();
        })
        .catch((error) => {
          console.log(error);
          console.log(error.response);
        });
    } else {
      dontUseCashBack(this.selectedUserId)
        .then((response) => {
          this.getCartCMS();
        })
        .catch((error) => {
          console.log(error);
          console.log(error.response);
        });
    }
  };

  get isLeaderHavingAddress() {
    const { address1 = "" } = this.props.user || {};
    return address1 !== null;
  }

  get hasCartItems() {
    const { cartItems = [] } = this.props.cart || {};
    return Array.isArray(cartItems) && cartItems.length > 0;
  }

  get selectedUserId() {
    return this.props.selectedContact.user_id;
  }

  navigateToPlaceOrder = () => {
    this.props.dispatch &&
      this.props.dispatch(cartActions.getAllCartItems(this.selectedUserId));
    this.props.navigation &&
      this.props.navigation.navigate &&
      this.props.navigation.replace("Customer");
  };

  toggleIsWhatsappOpted = () => {
    this.setState({ isWhatsappOpted: !this.state.isWhatsappOpted }, () => {});
  };

  changeAddressClick = () => {
    const { navigation } = this.props;
    this.setState({ showAddressConfirmation: false }, () => {
      navigation.navigate &&
        navigation.push("TLAddress", { fromPlaceOrderFlow: true });
      analytics.trackEvent(ORDER_FLOW_EVENTS.CHANGE_ADDRESS_CLICK, {
        screen_name: "Detail Confirmation Pop",
      });
    });
  };

  setDefaultPaymentOption = (data) => {
    const paymentOptions =
      (data?.cartPage &&
        data?.cartPage.length &&
        data?.cartPage?.find(
          (cartItem) => cartItem.type === "paymentOptions",
        )) ||
      null;
    return paymentOptions?.default_method || "JUSPAY";
  };

  renderApplyCoupon = (cartDetails = {}) => {
    const {
      total = "",
      applied_coupon_code = "",
      is_coupon_valid = false,
      coupon_applied_message = "",
      not_applicable_message = "",
      text = "",
    } = cartDetails;

    return (
      <View
        style={{
          marginTop: metrics.baseGutter,
        }}
      >
        <DiscountView
          cartTotal={total}
          currentCartSkuIds={this.props.currentCartSkuIds}
          appliedCouponCode={applied_coupon_code}
          removeCouponCode={this.removeCouponCode}
          notApplicableMessage={not_applicable_message}
          couponAppliedMessage={coupon_applied_message}
          isCouponValid={is_coupon_valid}
          text={text}
        />
      </View>
    );
  };

  renderPaymentMode = (paymentOptions) => {
    const items = paymentOptions.items.map((paymentOption) => ({
      key: paymentOption.payment_method,
      text: paymentOption.partner_name,
      subTitle: paymentOption.sub_text,
      rightIcon: (
        <Image
          source={{ uri: paymentOption.icon }}
          style={{ height: 40, width: 45, alignSelf: "center" }}
        />
      ),
    }));

    return (
      <View>
        <View style={styles.subHeaderContainer}>
          <Text bold fontType="content1" style={styles.orderStatusText}>
            {paymentOptions.title}
          </Text>
        </View>
        <View style={{ backgroundColor: "#fff" }}>
          <RadioButton
            radioOptions={items}
            setSelectedOption={(method) => {
              this.setState({ paymentMethod: method });
            }}
            default={this.state.paymentMethod}
            active={this.state.paymentMethod}
          />
        </View>
      </View>
    );
  };

  renderProductsWithEdd = (products) => {
    const productList = products.items.map((product) => ({
      title: product.title,
      data: product.items,
    }));

    return (
      <ViewShot
        style={styles.imageBackground}
        ref={(ref) => (this.viewShotRef = ref)}
        options={{ format: "jpg", quality: 0.9 }}
      >
        <SectionList
          sections={productList}
          keyExtractor={(item, index) => index.toString()}
          renderItem={({ item }) => (
            <CartProductItem
              data={item}
              updateCart={() => this.getCartCMS()}
              customerId={this.selectedUserId}
            />
          )}
          renderSectionHeader={({ section: { title } }) => (
            <View style={styles.subHeaderContainer}>
              <Text bold fontType="content1" style={styles.orderStatusText}>
                {title}
              </Text>
            </View>
          )}
        />
      </ViewShot>
    );
  };

  renderWalletBalance = (cartItem) => {
    const {
      use_wallet_balance_text_template,
      wallet_balance_text,
      wallet_balance,
      checked,
    } = cartItem;

    return (
      <View style={styles.walletContainer}>
        <View style={{ flexDirection: "row", alignItems: "center" }}>
          <CheckBox
            value={checked}
            tintColors={{ true: colors.primary }}
            onValueChange={(newValue) => this.toggleUseCashBack(newValue)}
          />
          <Text fontType="head3">{use_wallet_balance_text_template}</Text>
        </View>
        <View
          style={{
            alignItems: "center",
          }}
        >
          <Text>{wallet_balance_text}</Text>
          <Text fontType="head2" bold>
            {wallet_balance}
          </Text>
        </View>
      </View>
    );
  };

  renderBillingDetails = (cartDetails = {}) => {
    const { title = "", items = [] } = cartDetails;

    return (
      <View style={styles.billingContainer}>
        <View style={[styles.subHeaderContainer, styles.subHeaderExtraPadding]}>
          <Text fontType="content1" style={styles.orderStatusText}>
            {title}
          </Text>
        </View>
        <View style={styles.billingDetails}>
          {items.length > 0 &&
            items.map((item) => (
              <View
                style={[
                  styles.priceContainer,
                  item.borderTop ? styles.horizontal : null,
                ]}
              >
                <Text fontType="content2" style={styles.price}>
                  {item.text}
                </Text>
                <Text
                  fontType="content2"
                  style={[
                    styles.price,
                    item.amountGreen ? styles.free : {},
                    item.borderTop ? { fontWeight: "bold" } : {},
                  ]}
                >
                  {item.amount}
                </Text>
              </View>
            ))}
        </View>
      </View>
    );
  };

  renderShippingDetails = (shippingDetails) => {
    const { title, name, address, subText } = shippingDetails;

    return (
      <View>
        <View style={[styles.subHeaderContainer, styles.subHeaderExtraPadding]}>
          <Text fontType="content1" style={styles.orderStatusText} />
          <Text fontType="content1" style={styles.orderStatusText}>
            {title}
          </Text>
        </View>
        <View style={[styles.billingContainer, { marginBottom: 30 }]}>
          <View
            style={[
              styles.priceContainer,
              {
                flexDirection: "column",
                alignItems: "flex-start",
                paddingBottom: 10,
              },
            ]}
          >
            <Text
              style={{
                marginVertical: 5,
              }}
              fontType="head2"
            >
              {name}
            </Text>
            <Text fontType="content2" style={styles.price}>
              {address}
            </Text>
            {Boolean(subText) && (
              <Text
                fontType="content3"
                style={[styles.price, { marginTop: 10 }]}
              >
                {subText}
              </Text>
            )}
          </View>
        </View>
      </View>
    );
  };

  bottomPriceView = () => {
    const { whatsapp_opted_in = false } = this.props.user || {};

    const bottomStrip =
      this.state.cart &&
      this.state.cart.cartPage &&
      this.state.cart.cartPage.length > 0 &&
      this.state.cart.cartPage.find(
        (cartItem) => cartItem.type === "redBottomStrip",
      );
    return (
      <>
        {bottomStrip && (
          <View style={styles.bottomStrip}>
            {Boolean(
              bottomStrip.minCartWarning && bottomStrip.minCartWarning.show,
            ) && (
              <View
                style={{
                  marginBottom: 5,
                  flexDirection: "row",
                  alignItems: "center",
                }}
              >
                <Image
                  resizeMode="contain"
                  source={{
                    uri: bottomStrip.minCartWarning.icon,
                  }}
                  style={{
                    height: normalize(15),
                    width: normalize(15),
                    marginRight: 10,
                  }}
                />
                <Text style={styles.bottomStripText} fontType="head3">
                  {bottomStrip.minCartWarning.text}
                </Text>
              </View>
            )}
            {!whatsapp_opted_in &&
              !(
                bottomStrip.minCartWarning && bottomStrip.minCartWarning.show
              ) && (
                <View
                  style={{
                    marginBottom: 5,
                    flexDirection: "row",
                    alignItems: "center",
                  }}
                >
                  <CheckBox
                    value={this.state.isWhatsappOpted}
                    tintColors={{ true: colors.white }}
                    onValueChange={(newValue) =>
                      this.setState({
                        isWhatsappOpted: newValue,
                      })
                    }
                  />
                  <Text style={styles.bottomStripText} fontType="head3">
                    {t(`${PATH}/subscribeForWA`)}
                  </Text>
                </View>
              )}
            <View
              style={{
                flexDirection: "row",
                justifyContent: "space-between",
                flexWrap: "wrap",
              }}
            >
              <View style={{ width: width * 0.6 }}>
                <View
                  style={{
                    flexDirection: "row",
                    flexWrap: "wrap",
                    marginRight: 4,
                  }}
                >
                  <Text style={styles.bottomStripText} fontType="content2">
                    {bottomStrip.subTitle}
                  </Text>
                </View>
                <View style={{ flexDirection: "row" }}>
                  <Text
                    style={[
                      styles.bottomStripText,
                      styles.bottomStripPrice,
                      { marginRight: 10 },
                    ]}
                    fontType="head2"
                  >
                    {bottomStrip.amount}
                  </Text>
                  <Text
                    style={[
                      styles.bottomStripText,
                      { textDecorationLine: "line-through", fontSize: 14 },
                    ]}
                    fontType="head2"
                  >
                    {bottomStrip.amountStrikeThrough}
                  </Text>
                </View>
              </View>
              <TouchableOpacity
                disabled={
                  (bottomStrip.minCartWarning &&
                    bottomStrip.minCartWarning.show) ||
                  this.state.isOrderSubmitting
                }
                style={styles.bottomStripButton}
                onPress={() => this.checkForOOSProducts(false)}
              >
                {this.state.isOrderSubmitting ? (
                  <ActivityIndicator size="small" color={colors.primary} />
                ) : (
                  <Text
                    bold
                    style={{
                      color:
                        this.state.cart.showOosWarning ||
                        (bottomStrip.minCartWarning &&
                          bottomStrip.minCartWarning.show)
                          ? "rgba(0,0,0,0.36)"
                          : "#000",
                      fontSize: 16,
                    }}
                  >
                    {bottomStrip.ctaText}
                  </Text>
                )}
              </TouchableOpacity>
            </View>
          </View>
        )}
      </>
    );
  };

  renderCartCms = (cartPageItem) => {
    const { cms_id, cms_type } = cartPageItem;

    const { selectedContact, cart } = this.props;

    return (
      <View
        style={{
          flex: 1,
          backgroundColor: "white",
        }}
      >
        <FetchCMSEntity
          customEvent={SHARING_EVENTS.CART_SHSARE}
          customEventData={{
            cx_id: selectedContact?.user_id,
            cart_items: cart?.cartItems,
            cart_total: cart?.cartDetails?.total,
            cart_comission: cart?.commission,
          }}
          captureRef={this.viewShotRef}
          id={cms_id}
          type={cms_type}
          userPhone={selectedContact?.user_phone}
        />
      </View>
    );
  };

  renderCartItems = (cartPageItem, index) => {
    switch (cartPageItem.type) {
      case "cart_cms":
        return this.renderCartCms(cartPageItem);
      case "applyCouponCode":
        return this.renderApplyCoupon(cartPageItem);
      case "paymentOptionsV2":
        return this.renderPaymentMode(cartPageItem);
      case "cartItemsByEdd":
        return this.renderProductsWithEdd(cartPageItem);
      case "useWalletBalance":
        return cartPageItem.show && this.renderWalletBalance(cartPageItem);
      case "billingDetails":
        return this.renderBillingDetails(cartPageItem);
      case "shippingDetails":
        return this.renderShippingDetails(cartPageItem);
      default:
        return null;
    }
  };

  CMS_KEY = "CART_PAGE";

  render() {
    const { isLargeAppliancePresent, showAddressConfirmation, cart } =
      this.state;
    const isCartEmpty =
      this.state.cart &&
      this.state.cart.cartPage &&
      this.state.cart.cartPage.length > 0 &&
      this.state.cart.cartPage.find(
        (cartItem) => cartItem.type === "cartItemsByEdd",
      ).items.length === 0;

    if (this.state.isFirstLoad) {
      return (
        <View style={styles.loaderContainer}>
          <ActivityIndicator color={colors.primary} size="large" />
        </View>
      );
    }

    if (isCartEmpty) {
      return (
        <View style={styles.noItemsContainer}>
          <CartEmpty />
          <Text
            fontType="head3"
            style={{
              color: colors.mediumBlack,
              marginBottom: 20,
              width: "60%",
              textAlign: "center",
            }}
          >
            {t(`${PATH}/emptyCart`)}
          </Text>
          <Button
            btnText={t(`${PATH}/searchProduct`)}
            buttonWidth={Dimensions.get("window").width / 2.5}
            height={Dimensions.get("window").height / 14}
            borderRadius={10}
            onPress={() => this.props.navigation.goBack()}
            textStyle={{
              textAlign: "center",
              fontFamiy: "NotoSansDevanagari-Bold",
              fontSize: 20,
            }}
            buttonStyle={{
              marginTop: 30,
            }}
          />
        </View>
      );
    }

    if (!isCartEmpty && !this.state.isFirstLoad) {
      return (
        <View style={styles.mainContainer}>
          <ScrollView testID={testIds.Confirm_Order_Screen}>
            {this.state.cart &&
            this.state.cart.cartPage &&
            Array.isArray(this.state.cart.cartPage)
              ? this.state.cart.cartPage.map((cartPageItem, index) =>
                  this.renderCartItems(cartPageItem),
                )
              : null}

            {this.props.cmsPoweredEntities &&
            typeof this.props.cmsPoweredEntities === "object" &&
            this.CMS_KEY in this.props.cmsPoweredEntities ? (
              <CartContext.Provider
                value={{
                  updateCart: debounce(this.getCartCMS, 300),
                  sadf: "asdf",
                }}
              >
                <FetchCMSEntity
                  id={this.props.cmsPoweredEntities[this.CMS_KEY]}
                  type="PAGE"
                />
              </CartContext.Provider>
            ) : null}
          </ScrollView>
          {this.hasCartItems && this.bottomPriceView()}

          {this.state.cart && this.state.cart.showOosWarning && (
            <OssModal
              visible={this.state.removedItemsFromCartModalShown}
              data={this.state.cart.oosPage}
              loadingCartConfirm={this.state.isOrderSubmitting}
              handleClose={() =>
                this.setState({
                  removedItemsFromCartModalShown: false,
                })
              }
              handlePlaceOrder={() => this.placeOrder(true, false)}
            />
          )}
          {isLargeAppliancePresent && (
            <View>
              <AddressConfirmationModal
                visible={showAddressConfirmation}
                onAddressChangeClick={this.changeAddressClick}
                onConfirmOrderClick={() => this.checkForOOSProducts(true)}
                details={cart.cartPage}
                onClose={() => {
                  this.setState({ showAddressConfirmation: false });
                  analytics.trackEvent(
                    ORDER_FLOW_EVENTS.DETAIL_CONFIRMATION_CLOSE_CLICK,
                  );
                }}
              />
            </View>
          )}
        </View>
      );
    }
  }
}

const mstp = ({
  auth: { user, tracking_info },
  cart,
  leader: { users = [] },
  customer,
  configReducer,
}) => {
  const { userForOrder } = cart;
  // const  userForOrder = customer.selectedContact;
  const { selectedContact } = customer;
  const selectedUser = userForOrder || {};
  const { cmsPoweredEntities = {} } = configReducer.appSettings;
  return {
    user,
    cart,
    users,
    selectedUser,
    tracking_info,
    selectedContact,
    currentCartSkuIds: getAddedProductListIds(cart),
    cmsPoweredEntities,
  };
};

const styles = StyleSheet.create({
  mainContainer: {
    flex: 1,
    width: "100%",
    backgroundColor: colors.darkBackground,
  },
  loaderContainer: {
    justifyContent: "center",
    alignItems: "center",
    flex: 1,
  },
  walletContainer: {
    marginTop: metrics.baseGutter,
    backgroundColor: "white",
    padding: metrics.baseGutter,
    flexDirection: "row",
    justifyContent: "space-between",
  },
  orderStatusText: {
    fontSize: 16,
    color: colors.mediumBlack,
    fontWeight: "bold",
  },
  billingContainer: {
    flex: 1,
    backgroundColor: colors.white,
  },
  billingDetails: {
    paddingVertical: 5,
  },
  detailsContainer: {
    backgroundColor: "#fff",
    padding: metrics.baseGutter,
  },
  priceContainer: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    paddingVertical: 5,
    marginHorizontal: metrics.baseGutter,
  },
  price: {
    fontSize: 14,
    color: colors.lightBlack,
  },
  free: {
    fontSize: 14,
    color: colors.lima,
    fontWeight: "bold",
  },
  horizontal: {
    borderTopWidth: 1,
    borderTopColor: "rgba(0,0,0,0.1)",
  },
  image: {
    width: Dimensions.get("window").width / 5,
    height: Dimensions.get("window").width / 5,
  },
  noItemsContainer: {
    flex: 1,
    width: "100%",
    justifyContent: "center",
    alignItems: "center",
    alignContent: "center",
    alignSelf: "center",
    backgroundColor: colors.white,
  },
  subHeaderContainer: {
    backgroundColor: colors.primaryBg,
    padding: metrics.baseGutter,
  },
  subHeaderExtraPadding: {
    paddingTop: metrics.baseGutter * 2,
  },
  bottomStrip: {
    backgroundColor: "#C90022",
    borderTopLeftRadius: 10,
    borderTopRightRadius: 10,
    paddingHorizontal: 15,
    paddingVertical: 10,
  },
  bottomStripText: {
    color: "#fff",
    fontSize: 14,
  },
  bottomStripPrice: {
    fontWeight: "bold",
  },
  bottomStripButton: {
    marginLeft: "auto",
    paddingVertical: 8,
    // paddingHorizontal: 25,
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "white",
    borderRadius: 6,
    width: width * 0.3,
  },
});

export default connect(mstp)(PlaceOrderHOC(PlaceOrderView));
